import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'maplibre-gl/dist/maplibre-gl.css';
import "core-js/stable";
import "regenerator-runtime/runtime";
import { GoogleOAuthProvider } from '@react-oauth/google';
import appConfig from './config/appConfig';
import AppErrorBoundary from './components/AppErrorBoundary';
import { ThemeProvider } from './context/ThemeContext';
import './assets/css/theme.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <GoogleOAuthProvider clientId={appConfig.auth.googleClientId || 'not-configured.apps.googleusercontent.com'}>
        <ThemeProvider><App /></ThemeProvider>
      </GoogleOAuthProvider>
    </AppErrorBoundary>
  </React.StrictMode>
);
// console.log('CRA env keys:', Object.keys(process.env).filter(k => k.startsWith('REACT_APP_')));
// console.log('REACT_APP_API_URL:', process.env.REACT_APP_API_URL);

reportWebVitals();



// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import 'maplibre-gl/dist/maplibre-gl.css';
// import "core-js/stable";
// import "regenerator-runtime/runtime";

// // ✅ Allow only Android and iOS
// const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

// const root = ReactDOM.createRoot(document.getElementById('root'));

// if (isMobile) {
//   root.render(
//     <React.StrictMode>
//       <App />
//     </React.StrictMode>
//   );
// } else {
//   // ❌ Desktop fallback screen
//   root.render(
//     <div style={{
//       height: '100vh',
//       background: 'linear-gradient(135deg, #2c3e50, #3498db)',
//       color: 'white',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       flexDirection: 'column',
//       textAlign: 'center',
//       padding: '2rem',
//       fontFamily: 'Segoe UI, sans-serif'
//     }}>
//       <img 
//         src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Google_Play_Store_badge_EN.svg/512px-Google_Play_Store_badge_EN.svg.png" 
//         alt="Get it on Google Play" 
//         style={{ maxWidth: '200px', marginBottom: '1rem' }}
//       />
//       <img 
//         src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" 
//         alt="Download on the App Store" 
//         style={{ maxWidth: '200px', marginBottom: '2rem' }}
//       />
//       <h1 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Mobile Only Access</h1>
//       <p style={{ fontSize: '1.1rem', marginBottom: '2rem', maxWidth: '500px' }}>
//         This application is only accessible on Android and iOS devices.
//         Please download and open it on your mobile device.
//       </p>
//       <div style={{ display: 'flex', gap: '1rem' }}>
//         <a 
//           href="https://play.google.com/store/apps/details?id=com.example.yourapp" 
//           target="_blank" 
//           rel="noopener noreferrer"
//           style={{
//             background: '#fff',
//             color: '#2c3e50',
//             padding: '0.75rem 1.5rem',
//             borderRadius: '8px',
//             fontWeight: 'bold',
//             textDecoration: 'none',
//             boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
//           }}
//         >
//           Play Store
//         </a>
//         <a 
//           href="https://apps.apple.com/app/id0000000000" 
//           target="_blank" 
//           rel="noopener noreferrer"
//           style={{
//             background: '#fff',
//             color: '#2c3e50',
//             padding: '0.75rem 1.5rem',
//             borderRadius: '8px',
//             fontWeight: 'bold',
//             textDecoration: 'none',
//             boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
//           }}
//         >
//           App Store
//         </a>
//       </div>
//     </div>
//   );
// }

// reportWebVitals();
